import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const InfoPanelTheme = {
    infoPanel: {
        light: {
            title: {
                note: {
                    backgroundColor: Colors.greyWhite,
                    color: Colors.black,
                },
                warning: {
                    backgroundColor: Colors.parisDaisy,
                    color: Colors.black,
                },
                padding: {
                    mobile: `${createCustomSpacing(11 / 16)} ${Spacings.small}`,
                    tablet: Spacings.medium,
                    desktop: `${Spacings.medium} ${Spacings.large}`,
                },
                marginBottom: { mobile: Spacings.xSmall, desktop: Spacings.small },
            },
            children: {
                padding: {
                    mobile: `${Spacings.xSmall} ${Spacings.small}`,
                    tablet: `${Spacings.xSmall} ${Spacings.medium}`,
                    desktop: `${Spacings.xSmall} ${Spacings.large}`,
                },
            },
        },
        dark: {
            title: {
                note: {
                    backgroundColor: withOpacity(Colors.white, Opacities.xLow),
                    color: Colors.white,
                },
                warning: {
                    backgroundColor: Colors.parisDaisy,
                    color: Colors.black,
                },
                padding: {
                    mobile: `${createCustomSpacing(11 / 16)} ${Spacings.small}`,
                    tablet: Spacings.medium,
                    desktop: `${Spacings.medium} ${Spacings.large}`,
                },
                marginBottom: { mobile: Spacings.xSmall, desktop: Spacings.small },
            },
            children: {
                padding: {
                    mobile: `${Spacings.xSmall} ${Spacings.small}`,
                    tablet: `${Spacings.xSmall} ${Spacings.medium}`,
                    desktop: `${Spacings.xSmall} ${Spacings.large}`,
                },
            },
        },
    },
};
export default InfoPanelTheme;
